export default {
  header: 'Klucze API',
  subheader: 'Klucze API służą do uzyskiwania programowego dostępu do API Qmulus.\nKażdy klucz automatycznie dziedziczy uprawnienia użytkownika i działa w jego imieniu',
  qmulusApiUrl: 'Adres URL API Qmulus',
  openApiSpecification: 'Specyfikacja OpenAPI',
  openApiExplorer: 'Otwórz eksplorator API',
  noApiAccess: 'Tworzenie i edytowanie kluczy API wymaga dostępu do API. Poproś administratora o jego przyznanie.',
};
